"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLiveVideo = exports.isYoutubeVideo = exports.isFacebookVideo = exports.isVideoOriginallyLive = exports.isVideoFromComputer = exports.isExternalVideoSource = exports.isExternalVideo = exports.isDownloadAllowed = void 0;
var video_sources_1 = require("@wix/wix-vod-constants/dist/common/video-sources");
var item_type_1 = require("@wix/wix-vod-constants/dist/api-types/enums/item-type");
var lodash_1 = require("lodash");
var video_sources_2 = require("@wix/wix-vod-constants/dist/common/video-sources");
exports.isDownloadAllowed = function (video) { return video.allowDownload; };
exports.isExternalVideo = function (video) {
    return Boolean(video.mediaExternUrl);
};
exports.isExternalVideoSource = function (videoSource) {
    return video_sources_2.EXTERNAL_VIDEO_SOURCES.includes(videoSource);
};
exports.isVideoFromComputer = function (_a) {
    var videoSource = _a.videoSource;
    return videoSource === video_sources_1.VIDEO_SOURCES.COMPUTER;
};
exports.isVideoOriginallyLive = function (_a) {
    var videoSource = _a.videoSource;
    return videoSource === video_sources_1.VIDEO_SOURCES.LIVE;
};
exports.isFacebookVideo = function (_a) {
    var videoSource = _a.videoSource;
    return videoSource === video_sources_1.VIDEO_SOURCES.FACEBOOK;
};
exports.isYoutubeVideo = function (_a) {
    var videoSource = _a.videoSource;
    return videoSource === video_sources_1.VIDEO_SOURCES.YOUTUBE;
};
exports.isLiveVideo = function (_a) {
    var itemType = (_a === void 0 ? {} : _a).itemType;
    return lodash_1.includes([item_type_1.ItemType.ItemLive, item_type_1.ItemType.ItemScheduled, item_type_1.ItemType.ItemLiveFinalize], itemType);
}; //TODO check if works
//# sourceMappingURL=video-origin.js.map